export enum UpsellBookingProps {
  upsellId = 'upsellId',
  upsellOptionId = 'upsellOptionId'
}
